/*
    Description: research search box class
    Author URI: https://destinationsalesandmarketinggroup.com/
    Author: adillice
    Version: 1.0.0
*/

//import utility class for ajax call
import Utilities from "./utilities";

// research search class
class ResearchSearch extends Utilities{

    // constructor
    constructor({

        // get DOM search box element
        searchBox = ".js-research-search",
        wpnonce = "report-search"
        
    }={}){

        // get constructor/params from Utilities
        super();
        
        // init selectors
        this.searchBox = document.querySelector(searchBox);
        this.searchBoxWrapper = (this.searchBox) ? this.searchBox.parentNode : null;
        this.header = document.querySelector("header");

        // add searchError class
        this.searchError = "js-research-search-error";

        // add search result position class
        this.searchResultPosition = "js-research-reverse";

        // close bttn class
        this.closeBttnClass = "js-research-close";
        this.closeBttnPadding = "--research-close-padding";

        // report download class and general report class 
        this.downloadFile = "js-research-download";
        this.reportFileClass = "--js-report-file";

        // add cancel class
        this.cancel = "--research-search-cancel";

        // add loading class
        this.loading = "--loading";

        // add hide class
        this.hide = "--hide";

        // message for empty search
        this.emptyMsg = "We couldn't find a match for [[term]]. Please try again.";
        
        // critical error msg
        this.criticalError = "ERROR: There was a critical ajax error. We could not retrieve anything from the API.";

        // create error node and add class
        this.errorWrapper = document.createElement("p");
        this.errorWrapper.classList.add(this.searchError, "--error");

        // blacklist classes
        this.blackListClasses = ["modal", "reports", "loading"];

        // wpnonce
        this.nonce = wpnonce;

        // key stroke delay time - [milliseconds]
        this.keyDelayTime = 369;

        // init key stroke delay
        this.keyDelay = null;

        // search limit
        this.searchLimit = 10;

        // character limit
        this.start = 3;

        // fire off events
        this.events();

    }

    //EVENTS methods
    events(){

        // set self to this
        const that = this;

        // check if search box exists
        if(this.searchBox){

            // init search box reset
            this.searchBox.value = "";

            // keydown event
            this.searchBox.addEventListener("keyup", this.keysPressed.bind(this));

            // check if we can click outside
            if(document.body){

                // add event to videos selector
                document.body.addEventListener("click", function(e){

                    // get outside click area
                    const area = that.searchBoxWrapper,

                    // get target
                    target = e.target,

                    // get first class of target
                    targetFirstClass = (target.classList && (target.classList.length > 0)) ? target.classList[0] : null,

                    // get black listed value
                    targetClassBlackList = (targetFirstClass && ((targetFirstClass.indexOf(that.blackListClasses[0]) > -1) || (targetFirstClass.indexOf(that.blackListClasses[1]) > -1) || (targetFirstClass.indexOf(that.blackListClasses[2]) > -1))) ? true : false;
                    
                    // make sure we have area
                    if(area){
                        
                        // check if area clicked outside
                        if(!area.contains(e.target) && !targetClassBlackList){
                            
                            // make sure we are not currently loading data from api
                            if(that.searchBox && (!that.searchBox.classList.contains(that.loading))){

                                // close search results
                                that.closeSearch(null);

                            }
        
                        }
                        
                    }
        
                });

            }

        }

    }

    // add search close button 
    addCloseButton(){

        // get all close buttons
        const closeBttnCount = (this.searchBoxWrapper) ? this.searchBoxWrapper.querySelectorAll(`.${this.closeBttnClass}`) : null;
        
        // if we have a close button already just return  
        if(closeBttnCount.length > 0) return;

        // init close bttn
        // const close = document.createElement("span");
        const close = document.createElement("button");

        // setup accessibility
        close.setAttribute("aria-label", "reset report search results");
        close.setAttribute("role", "button");

        // add close button class
        close.classList.add(this.closeBttnClass);
        
        // add close bttn to search box wrapper
        this.searchBoxWrapper.appendChild(close);

        // add padding to input field to offset close button width
        if(this.searchBox) this.searchBox.classList.add(this.closeBttnPadding); 

        // add close functionality
        close.addEventListener("click", this.closeSearch.bind(this));

    }

    // close bttn method
    closeSearch(e){

        // prevent default click event
        if(e) e.preventDefault();

        // clean up results and any error msgs
        this.cleanUpResults();

        // check if we have searchbox
        if(this.searchBox){
            
            // clear input value
            this.searchBox.value = "";

            // remove close button padding
            this.searchBox.classList.remove(this.closeBttnPadding);

            // get close button
            const closeButton = this.searchBox.parentNode.querySelector(`.${this.closeBttnClass}`);
            
            // remove close button
            if(closeButton) closeButton.remove();
            
            // add cancel class
            this.searchBox.classList.add(this.cancel);

        }

        // remove close button
        if(e) e.target.remove();

    }

    // remove search results and msgs 
    cleanUpResults(){

        // get close button
        const closeBttn = (this.searchBoxWrapper) ? this.searchBoxWrapper.querySelector(`.${this.closeBttnClass}`) : null;

        // remove error msg if one exists
        if(this.searchBoxWrapper.querySelector(`.${this.searchError}`)) this.searchBoxWrapper.querySelector(`.${this.searchError}`).remove();

        // check if results exists
        if(this.searchBoxWrapper.querySelector("ul")){
            
            // remove scroll event listener
            document.removeEventListener("scroll", this.searchBoxPosition());
            
            // remove close button functionality
            if(closeBttn) closeBttn.removeEventListener("click", this.closeSearch.bind(this));

            // remove ul result list
            this.searchBoxWrapper.querySelector("ul").remove();
            
        };

    }

    // setup searchbox position
    searchBoxPosition(){

        //init search results
        const resultBox = (this.searchBoxWrapper) ? this.searchBoxWrapper.querySelector("ul") : null;
        
        // check for resultBox
        if(resultBox){
            
            // calculate scroll position
            const scrollPosition = document.body.scrollTop, 
            
            // get input field position
            inputFieldPosition = this.searchBox.getBoundingClientRect().top,
            
            // get input field relative position
            relativePosition = (inputFieldPosition - scrollPosition),

            // get half of the window height
            winHeight = (window.innerHeight/2);

            // update class
            (relativePosition > winHeight) ? resultBox.classList.add(this.searchResultPosition) :  resultBox.classList.remove(this.searchResultPosition);

        }

    }

    // convert html entities
    convert(check){

        //return check 
        return check.replace(/&#(\d+);/g, function(match, value){
            
            return String.fromCharCode(value);
        
        });

    }

    // key event
    keysPressed(e){

        // prevent default
        e.preventDefault();
        
        // clear setTimeOut
        clearTimeout(this.keyDelay);

        // just return nothing if searchbox wrapper does not exist
        if(!this.searchBoxWrapper) return;

        // init search value
        const searchTerm = this.searchBox.value;

        // trim starting quote
        let trimmedQuotes = ((searchTerm)&&(searchTerm.charAt(0) === "'" || searchTerm.charAt(0) === '"')) ? searchTerm.slice(1) : searchTerm;
        
        // trim last quote
        trimmedQuotes = ((trimmedQuotes)&&(trimmedQuotes.charAt(trimmedQuotes.length - 1) === "'" || trimmedQuotes.charAt(trimmedQuotes.length - 1) === '"')) ? trimmedQuotes.slice(0, -1) : trimmedQuotes;

        // get search term
        const searchValue = (trimmedQuotes) ? trimmedQuotes.replace(/[^A-Za-z0-9\-\—\_\:\;\$\&\(\)\,\'\. ]/g, "") : null;

        // clean up search results and any msgs
        this.cleanUpResults();

        // if escape was pressed exit and cleanup
        if(e.key.toLowerCase() === "escape"){
            
            // close search results
            this.closeSearch(null);
            
            // return
            return;
            
        }

        // setup setTimeOut
        this.keyDelay = setTimeout(() => {

            // make sure we have at least x chars
            if(searchValue.length >= this.start){

                // add class
                this.searchBox.classList.add(this.loading);
                
                // get close button (if it exists)
                const closeBttn = (this.searchBoxWrapper) ? this.searchBoxWrapper.querySelector(`.${this.closeBttnClass}`) : null;
                
                // add hide class
                if(closeBttn) closeBttn.classList.add(this.hide);

                // setup form data
                const data = new FormData();
                
                // append data
                data.append("report_search", searchValue);

                // get wpnonce value
                const nonce = document.getElementById(this.nonce);

                // make sure we have data
                if(nonce) data.append("wp_nonce", nonce.value);

                // send ajax
                this.ajax({
                    action:"reportSearch",      //go to "reportSearch" ajax method
                    data:data,                  //form data passed
                    loading:this.searchBox      //pass loading gif to input field for auto removal
                }).then((results) => {

                    //result clean up - double check incase of sync issue
                    this.cleanUpResults();

                    // make sure user didnt cancel search
                    if(this.searchBox.classList.contains(`${this.cancel}`)){
                        
                        //remove cancel class with toggle since remove() was being unreliable
                        this.searchBox.classList.toggle(this.cancel);
                        
                    }

                    //parse results
                    results = JSON.parse(results);

                    // check for any response
                    if(results){

                        // displat close button
                        if(closeBttn) closeBttn.classList.remove(this.hide);

                        // add close button
                        this.addCloseButton();
                        
                    }

                    // SUCCESS: display success msg
                    if(results.success){

                        // make sure we have something returned
                        if(results.success.length > 0){

                            // create ul and close buttonelement
                            const ul = document.createElement("ul");

                            // loop
                            results.success.forEach((item) => {
                                
                                // init
                                const li = document.createElement("li"),
                                download = document.createElement("a"), 
                                a = document.createElement("a"),
                                thisTitle = this.convert(item.title);

                                // setup download icon
                                download.classList.add(this.downloadFile);
                                if(ajax.gated === "1") download.classList.add(this.reportFileClass);
                                if(ajax.gated === "") download.setAttribute("target", "_blank");
                                download.setAttribute("href", (ajax.gated === "1") ? "#" : item.url);
                                download.setAttribute("title", `Download the ${thisTitle} report file`);
                                download.setAttribute("aria-label", `Download the ${thisTitle} report file`);
                                download.setAttribute("data-num", item.file);
                                download.setAttribute("tabindex", 0);
                                
                                // set anchor attributes
                                a.setAttribute("href", item.link);
                                a.setAttribute("title", `Click here to read more about ${thisTitle}`);
                                a.setAttribute("aria-label", `Click here to read more about ${thisTitle}`);
                                a.setAttribute("tabindex", 0);

                                // add anchor copy
                                a.textContent = thisTitle;
                                
                                // add links to li
                                li.appendChild(a);
                                li.appendChild(download);

                                // add li to ul
                                ul.appendChild(li);

                            });

                            // add ul to input
                            this.searchBoxWrapper.appendChild(ul);

                            // update position before scroll
                            this.searchBoxPosition();

                            // event listener for ul position
                            document.addEventListener("scroll", this.searchBoxPosition.bind(this));
                            
                        // return is empty
                        }else{

                            // setup msg
                            const emptyMsg = this.emptyMsg.replace("[[term]]", `"${searchValue}"`);

                            // add error msg copy
                            this.errorWrapper.textContent = emptyMsg;

                            // add error to parent
                            this.searchBoxWrapper.appendChild(this.errorWrapper);

                        }

                    // error
                    }else{

                        // init error msg or default
                        const errMsg = (results.error) ? results.error.report_search : this.criticalError;
                        
                        // add error msg copy
                        this.errorWrapper.textContent = errMsg;

                        // add error to parent
                        this.searchBoxWrapper.appendChild(this.errorWrapper);

                    }

                // catch ajax error
                }).catch((err) => {
                    
                    // display error msg
                    console.log(`%c Error: ${err}.`, 'background:#f00; color:#fff');

                });
        
            }

        }, this.keyDelayTime);

    }

}

// export
export default ResearchSearch;